module.exports = "/_next/static/images/advantages-timer-f2dcc0a5d7252d58531542b510e28632.svg";